// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"7e3b890c5ecfa3ca","node_modules_dompurify_dist_purify_js":"2ec7f743154d76ce","node_modules_canvg_lib_index_es_js":"e0b603391136dec3"}[chunkId] + ".js";
};